import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  set<T>(key: string, value: T): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(
        `[SessionStorageService] Error setting key "${key}"`,
        error
      );
    }
  }

  get<T>(key: string): T | null {
    try {
      const stored = sessionStorage.getItem(key);
      return stored ? (JSON.parse(stored) as T) : null;
    } catch (error) {
      console.error(
        `[SessionStorageService] Error getting key "${key}"`,
        error
      );
      return null;
    }
  }

  remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error(
        `[SessionStorageService] Error removing key "${key}"`,
        error
      );
    }
  }

  clear(): void {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error(
        '[SessionStorageService] Error clearing sessionStorage',
        error
      );
    }
  }
}
